const mainFilesView = {
  templateUrl: '/modules/packageManagement/main-files-view/main-files-view.html',
  controller: 'mainFilesViewController',
};

angular
    .module('package-management.module')
    .component('mainFilesView', mainFilesView)
    .config(function ($stateProvider) {
        $stateProvider
            .state('files', {
                url: '/package-management',
                redirectTo: 'files.filemanagement',
                component: 'mainFilesView',
                resolve: {
                    auth: function (userService, $state, eventService) {
                        return userService
                            .resolve(['ACCESS_PACKAGES'])
                            .then(() => {
                            })
                            .catch(() => {
                                eventService.trigger('userservice:unauthorized');
                                $state.go('frontpage');
                            });
                    },
                }
            });
    });